import { graphql } from "../generated/gql";

export const tagFragment = graphql(`
  fragment Tag on Tag {
    id
    name
    description
    color
  }
`);
